import { format } from "date-fns";

export interface Column {
  id: 'diaInicial'|'diaFinal';
  label: string;
  width?:number|string;
  minWidth?: number;
  maxWidth?: number;
  align?: 'right' | 'center' | 'left';
  format?: (value: string|number) => string;
}

export const columns: readonly Column[] = [
  { id: 'diaInicial', label: 'Data Inicial', minWidth: 100, align: 'left',format: (value:string|number) => format(new Date(value),"dd/MM/yyyy")},
  { id: 'diaFinal', label: 'Data Final', minWidth: 100, align: 'left',format: (value:string|number) => format(new Date(value),"dd/MM/yyyy")}
];